import { Form } from 'react-bootstrap';

function AdminListRole({ selectedRoles, role, id, onClick }) {
  const isChecked = selectedRoles.includes(id);

  return (
    <Form.Group controlId={id}>
      <Form.Check 
        type="checkbox" 
        label={role} 
        checked={isChecked} 
        onChange={() => onClick(id)} 
      />
    </Form.Group>
  );
}

export default AdminListRole;
